import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

// image

import Abd2 from '../../images/about/ab1.jpg'
import Abd3 from '../../images/about/ab2.jpg'
import Abd4 from '../../images/about/ab3.jpg'
import Abd5 from '../../images/about/shape.png'

import SectionTitle from '../SectionTitle/SectionTitle';

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { SectionTitleShow = true } = props
    return (
        <section className={"" + props.hclass}>
            {/* <div className="shape">
                <img src={Ab} alt="" />
            </div>
            <div className="side-img">
                <img src={Abd1} alt="" />
            </div> */}
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <div className="image-1">
                                <img src={Abd2} alt="" />
                            </div>
                            <div className="image-2">
                                <img src={Abd3} alt="" />
                            </div>
                            <div className="image-3">
                                <img src={Abd4} alt="" />
                            </div>
                            <div className="image-4">
                                <img src={Abd5} alt="" />
                            </div>

                            <div className="since">
                                <div>
                                    <h2> <CountUp end={1999} enableScrollSpy>00</CountUp></h2>
                                    <p>Since</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="about-content">
                            {SectionTitleShow && (
                                <div className="col-12 text-start">
                                    <SectionTitle subtitle={'About Us'} title={'Who We Are'} />
                                </div>
                            )}
                            <h4 className='mt-4'>
                                OFL is an Australian-owned and operated international logistics company. Built by a team with a wealth of knowledge and
                                experience within the logistics and supply chain
                                industry, <b>we can provide end to end solutions
                                    to all our clients and partners</b>.
                            </h4>

                            <p>
                                Our global network ensures that we can assist
                                you with all your local, national and international
                                logistical and warehousing requirements whilst
                                still being able to offer a personalised service
                            </p>

                            <p>
                                By choosing OFL you get access to a network
                                that is deeply dedicated to ensure that all your
                                requirements are met and fulfilled at the highest
                                professional standards.
                            </p>

                            <ul>
                                <li>Comprehensive local, national, and international freight and logistics solutions</li>
                                <li>End-to-end supply chain management backed by industry expertise</li>
                                <li>Reliable and personalised service through a strong global logistics network</li>
                            </ul>

                            <div className="author-btn">
                                {/* <div className="author">
                                    <div className="image">
                                        <img src={Abd6} alt="" />
                                    </div>
                                    <div className="text">
                                        <img src={Abd7} alt="" />
                                        <span>Ceo & Founder</span>
                                    </div>
                                </div> */}
                                <div className="about-btn">
                                    <Link onClick={ClickHandler} to="/about" className="theme-btn">
                                        more about us
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default about;

